// This list of icons should be retrieved from backend

import medicalCameraSrc from '@/assets/img/riesterrcs.jpg'
import stetoscopeSrc from '@/assets/img/thinklabsSteto.jpg'
import ecgSrc from '@/assets/img/ecg.png'
import dentalCameraSrc from '@/assets/img/cameradentaire.png'
import onyxCameraSrc from '@/assets/img/cameraonyx.png'
import echographeSrc from '@/assets/img/echographe.png'

const icons = [
  {
    id: 'medical_camera',
    src: medicalCameraSrc
  },
  {
    id: 'visioconference_camera',
    src: 'https://content.etilize.com/RightMaximum/1031053790.jpg'
  },
  {
    id: 'stethoscope',
    src: stetoscopeSrc
  },
  {
    id: 'ecg',
    src: ecgSrc
  },
  {
    id: 'dental_camera',
    src: dentalCameraSrc
  },
  {
    id: 'onyx_camera',
    src: onyxCameraSrc
  },
  {
    id: 'visioconference_micro',
    src: 'https://www.stars-music.fr/medias/prodipe/v85-hd-59625.jpg'
  },
  {
    id: 'echographe',
    src: echographeSrc
  }
]

export default icons